// extracted by mini-css-extract-plugin
export default {"tableHeader":"NftEditionsTableHeader_tableHeader__z3uX8"};